import { createReducer } from '@reduxjs/toolkit';

import getArticlesTheme from '../../thunks/articles/getArticlesTheme';

const initialState = {
  loading: false,
  error: '',
  data: null,
  list: [],
};

const getArticlesThemeReducer = createReducer(initialState, {
  [getArticlesTheme.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getArticlesTheme.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    loading: false,
    data,
    list: data?.map(({ article_theme_name: name }) => ({ label: name, value: name }))
  }),
  [getArticlesTheme.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getArticlesThemeReducer;
